export default "__VITE_ASSET__C4sO$UXy__"